/*eslint-disable*/
const allViewLists = [
        {type: 'points-history-homework'},
        {type: 'points-history-olympiad'},
        {type: 'points-history-battle'},
        {type: 'miles-history'},
        {type: 'detective-points-history'},
        {type: 'student'},
        {type: 'progress-homework'},
        {type: 'progress-olympiad'},
        {type: 'progress-battle'},
        {type: 'grade'},
        {type: 'homework'},
        {type: 'teacher'},
        {type: 'school'},
        {type: 'course'},
        {type: 'admin'},
        {type: 'rating'},
        {type: 'battle-rating'},
        {type: 'homework-template'},
        {type: 'transactions'},
        {type: 'presentations'},
        {type: 'statistics'},
        {type: 'stocks'},
        {type: 'payment-services'},
        {type: 'subscriptions'},
        {type: 'lesson-conducting-template'},
        {type: 'tariffs'},
];
const forbiddenViewListsForManagerOrSupport = [];
const viewListsForManagerOrSupport = allViewLists.filter(permission => !forbiddenViewListsForManagerOrSupport.includes(permission.type));
export default {
    addItem: {
        admin: [
            {type: 'teacher'},
            {type: 'student'},
            {type: 'grade'},
            {type: 'presentations'},
            {type: 'tariffs'}
        ],
        teacher: [
            {type: 'homework'},
            {type: 'homework-template'},
            {type: 'presentations'},
            {type: 'lesson-conducting-template'}
        ],
        student: [],
        'olympiads-student': [],
        support: [
            {type: 'teacher'},
            {type: 'student'},
            {type: 'admin'},
            {type: 'grade'},
            {type: 'school'},
            {type: 'homework'},
            {type: 'homework-template'},
            {type: 'lesson-conducting-template'},
            {type: 'presentations'},
            {type: 'course'},
            {type: 'stocks'},
            {type: 'payment-services'},
            {type: 'subscriptions'},
            {type: 'tariffs'}
        ],
        manager: [
            {type: 'teacher'},
            {type: 'student'},
            {type: 'admin'},
            {type: 'school'},
            {type: 'grade'},
            {type: 'homework'},
            {type: 'homework-template'},
            {type: 'lesson-conducting-template'},
            {type: 'presentations'},
            {type: 'course'},
            {type: 'stocks'},
            {type: 'payment-services'},
            {type: 'subscriptions'},
            {type: 'tariffs'}
        ],
    },
    viewList: {
        admin: [
            {type: 'points-history-homework'},
            {type: 'points-history-olympiad'},
            {type: 'points-history-battle'},
            {type: 'miles-history'},
            {type: 'detective-points-history'},
            {type: 'student'},
            {type: 'progress-homework'},
            {type: 'progress-olympiad'},
            {type: 'progress-battle'},
            {type: 'grade'},
            {type: 'teacher'},
            {type: 'school'},
            {type: 'admin'},
            {type: 'rating'},
            {type: 'battle-rating'},
            {type: 'transactions'},
            {type: 'presentations'},
            {type: 'statistics'},
            {type: 'tariffs'},
        ],
        teacher: [
            {type: 'points-history-homework'},
            {type: 'points-history-olympiad'},
            {type: 'points-history-battle'},
            {type: 'miles-history'},
            {type: 'detective-points-history'},
            {type: 'student'},
            {type: 'progress-homework'},
            {type: 'progress-olympiad'},
            {type: 'progress-battle'},
            {type: 'grade'},
            {type: 'homework'},
            {type: 'teacher'},
            {type: 'school'},
            {type: 'rating'},
            {type: 'battle-rating'},
            {type: 'homework-template'},
            {type: 'lesson-conducting-template'},
            {type: 'presentations'},
            {type: 'tariffs'},
        ],
        student: [
            {type: 'points-history-homework'},
            {type: 'points-history-olympiad'},
            {type: 'points-history-battle'},
            {type: 'miles-history'},
            {type: 'detective-points-history'},
            {type: 'student'},
            {type: 'progress-homework'},
            {type: 'progress-olympiad'},
            {type: 'progress-battle'},
            {type: 'battle-rating'},
            {type: 'rating'},
        ],
        'olympiads-student': [
            {type: 'progress-olympiad'}
        ],
        manager: viewListsForManagerOrSupport,
        support: viewListsForManagerOrSupport
    }
}
